import { inject, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { AppUtils } from '../../utils/app.utils';

@Pipe({
  name: 'formatDate',
  standalone: false,
})
export class FormatDatePipe implements PipeTransform {
  private readonly datePipe: DatePipe = inject(DatePipe);

  transform(date?: Date | string): string {
    const defaultDateFormat: string = 'yyyy-MM-dd';
    const dateFormat: string = environment.stores.find(
      store => store.storeId === AppUtils.getCurrentStore().storeId
    )?.dateFormat ?? defaultDateFormat;

    date = (typeof date === 'string') ? new Date(date) : date;

    return this.datePipe.transform(date, dateFormat) || '';
  }
}
